


export var cargo = require('url:/src/assets/images/cargo.png') //
export var cargo_flip = require('url:/src/assets/images/cargo_flip.png')//

export var plane = require('url:/src/assets/images/plane.png')
export var plane_flip = require('url:/src/assets/images/plane_flip.png')

export var jet = require('url:/src/assets/images/jet.png') //
export var jet_flip = require('url:/src/assets/images/jet_flip.png')//

export var turboprop = require('url:/src/assets/images/turboprop.png') //
export var turboprop_flip = require('url:/src/assets/images/turboprop_flip.png')//

export var medium = require('url:/src/assets/images/medium-plane.png')
export var medium_flip = require('url:/src/assets/images/medium-plane_flip.png')

export var light = require('url:/src/assets/images/light-plane.png')
export var light_flip = require('url:/src/assets/images/light-plane_flip.png')

export var super_light = require('url:/src/assets/images/super-light-plane.png') //
export var super_light_flip = require('url:/src/assets/images/super-light-plane_flip.png') //

export var glider = require('url:/src/assets/images/glider.png')
export var glider_flip = require('url:/src/assets/images/glider_flip.png')

export var helicopter = require('url:/src/assets/images/helicopter.png')
export var helicopter_flip = require('url:/src/assets/images/helicopter_flip.png')

export var ulm = require('url:/src/assets/images/ultra-light-plane.png')
export var ulm_flip = require('url:/src/assets/images/ultra-light-plane_flip.png')


export var military = require('url:/src/assets/images/military.png')
export var military_flip = require('url:/src/assets/images/military_flip.png')

export var samu = require('url:/src/assets/images/samu.gif')
export var samu_flip = require('url:/src/assets/images/samu_flip.gif')

export var ground_vehicle = require('url:/src/assets/images/gound-vehicle.png')
export var ground_vehicle_flip = require('url:/src/assets/images/gound-vehicle_flip.png')

export var drone = require('url:/src/assets/images/drone.png')
export var drone_flip = require('url:/src/assets/images/drone.png')





export var unknown = require('url:/src/assets/images/unknown-plane.png')
export var unknown_flip = require('url:/src/assets/images/unknown-plane_flip.png')

export var question_mark = require('url:/src/assets/images/unknown.png')